
import { lazy } from "react";
import { RouteDefinition } from "../../types";

const TrainingLinkedinPage = lazy(() => import("@/pages/TrainingLinkedinPage"));
const FineTuningPage = lazy(() => import("@/pages/FineTuningPage"));
const AiAssistantPage = lazy(() => import("@/pages/AiAssistantPage"));
const AiAssistantTrainingPage = lazy(() => import("@/pages/AiAssistantTrainingPage"));
const MenuDescriptionsPage = lazy(() => import("@/pages/MenuDescriptionsPage"));
const MenuTutorialVideosPage = lazy(() => import("@/pages/MenuTutorialVideosPage"));

const WebsiteCrawlerPage = lazy(() => import("@/pages/WebsiteCrawlerPage"));

export const trainingRoutes: RouteDefinition[] = [
  {
    path: "/website-crawler",
    component: WebsiteCrawlerPage,
    requiresAuth: true,
    title: "Website Crawler & AI Training",
    description: "Crawl your website content and prepare it for AI training and vector storage",
    name: "Website Crawler",
    category: "Training"
  },
  {
    path: "/training-short-form",
    component: TrainingLinkedinPage,
    requiresAuth: true,
    title: "Training Social Media (LinkedIn)",
    description: "LinkedIn training and automation",
    name: "Training LinkedIn",
    category: "Training"
  },
  {
    path: "/fine-tuning",
    component: FineTuningPage,
    requiresAuth: true,
    title: "Fine-Tuned Models Management",
    description: "Manage OpenAI fine-tuned models and training progress",
    name: "Fine-Tuning Models",
    category: "Training"
  },
  {
    path: "/ai-assistant",
    component: AiAssistantPage,
    requiresAuth: true,
    title: "AI Assistant Management",
    description: "Manage your OpenAI AI assistants",
    name: "AI Assistants",
    category: "Training"
  },
  {
    path: "/ai-assistant-training",
    component: AiAssistantTrainingPage,
    requiresAuth: true,
    title: "Internal AI Training Status",
    description: "Monitor and manage the training, knowledge base, and capabilities of your internal AI assistant",
    name: "AI Training Status",
    category: "Training"
  },
  {
    path: "/menu-descriptions",
    component: MenuDescriptionsPage,
    requiresAuth: true,
    title: "Menu Descriptions Manager",
    description: "Edit business descriptions and context for all menu items to improve AI assistant training",
    name: "Menu Descriptions",
    category: "Training"
  },
  {
    path: "/admin/menu-tutorial-videos",
    component: MenuTutorialVideosPage,
    requiresAuth: true,
    title: "Menu Tutorial Videos",
    description: "Assign tutorial videos to menu items for user onboarding",
    name: "Menu Tutorial Videos",
    category: "Admin"
  }
];
